import { App, Button, Card, Form, Select, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import LayoutHeader from '../../../adminnavigation/layoutHeader';
import { DELETE, GET, POST } from '../../../utils/apicalls';
import { API } from '../../../config/api';

function CourseEnquiry() {
    const [isLoading, setIsLoading] = useState(false);
    const [allEnquiry, setallEnquiry] = useState<any>([]);
    const [allCourseData, setallCourseData] = useState<any>([]);
    const { notification } = App.useApp();
    const [CourseFilterData, setCourseFilterData] = useState<any>([]);
    const [form1] = Form.useForm();
    const featchallEnquiry = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSE_ENQUIRIES, {});
            setallEnquiry(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        featchallEnquiry();
    }, []);
    const feacthallCourse = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setallCourseData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        feacthallCourse();
    }, []);

    const handleDelete = async (id: any) => {
        try {
            setIsLoading(true);
            const delete_customer_url = `${API.DELETE_COURSE_ENQUIRY}${id}`;
            const data: any = await DELETE(delete_customer_url);

            if (data.status) {
                notification.success({ message: " deleted successfully!" });
                featchallEnquiry();
            } else {
                notification.error({
                    message: "Something went wrong! Please try again later.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const confirmDelete = (id: any) => {
        const confirm = window.confirm(
            "Are you sure you want to delete this review?"
        );
        if (confirm) {
            handleDelete(id);
        }
    };

    const columns = [
        {
            title: "Index",
            dataIndex: "index",
            render: (_: any, __: any, index: number) => index + 1,
        },
        { title: "name", dataIndex: "name" },
        { title: "email", dataIndex: "email" },
        { title: "phone", dataIndex: "phone" },
        { title: "message", dataIndex: "message" },
        {
            title: "Course",
            dataIndex: "Course_id",
            key: "course",
            render: (Course_id: number) => {
                const category = allCourseData.find((cat: any) => cat.id === Course_id);
                return category ? category.course_title : 'Unknown';
            }
        },
        {
            title: "Actions",
            key: "actions",
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type="link" onClick={() => confirmDelete(record.id)}>Delete</Button>

                </Space>
            ),
        },
    ];

    const filterCourseData = async (values: any) => {
        try {
            setIsLoading(true);
            const api = API.FILTER_COURSE_ENQUIRY;
            const response: any = await POST(api, values);

            if (response?.status && response.data.length > 0) {
                setCourseFilterData(response.data);
            } else {
                setCourseFilterData([]);
                notification.info({
                    message: "No data found for the selected course.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({ message: "An error occurred while filtering." });
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <LayoutHeader />
            <h1 className="text-2xl font-bold mb-4 text-center" style={{ textAlign: "center" }}>Course Enquiry Management</h1>
            <Card>
                <h2 className="text-center mt-4">Course Enquiry List</h2>
                <Card className="mb-4">
                    <Form
                        form={form1}
                        layout="inline"
                        onFinish={filterCourseData}
                        style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                    >
                        <Form.Item
                            label="Course"
                            name="Course_id"
                        // rules={[{ required: true, message: 'Please select a Course!' }]}
                        >
                            <Select placeholder="Select a Course" allowClear>
                                {allCourseData.map((Course: { id: number; course_title: string }) => (
                                    <Select.Option key={Course.id} value={Course.id}>
                                        {Course.course_title}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Filter
                            </Button>
                            <Button
                                style={{ marginLeft: 8 }}
                                onClick={() => {
                                    form1.resetFields();
                                    setCourseFilterData([]); // Clear filtered data
                                    feacthallCourse();
                                }}
                            >
                                Reset
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>

                <Table
                    columns={columns}
                    // dataSource={allEnquiry}
                    dataSource={CourseFilterData.length ? CourseFilterData : allEnquiry}
                    loading={isLoading}
                    pagination={{ pageSize: 5 }}
                    scroll={{ x: "max-content" }}
                />
            </Card>

        </div>
    );
}
export default CourseEnquiry
